import { Controller } from "@hotwired/stimulus";

// Self-filling Locals feed: drop <div data-controller="locals-feed"></div>
// anywhere (e.g. the CMS homepage under the button row) and it pulls in the live
// server-rendered feed of profile tiles. The /feed endpoint re-randomises its
// sample on every request, so each page load shows a fresh set.
export default class extends Controller {
  static values = { url: { type: String, default: "/feed" } };

  connect() {
    fetch(this.urlValue, { headers: { "X-Requested-With": "XMLHttpRequest" }, credentials: "same-origin" })
      .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
      .then((html) => { this.element.innerHTML = html; })
      .catch(() => { /* leave the container empty on failure */ });
  }
}
